import { API } from './apiWrapper';

export const deleteSchool = async (categoryId: string) => {
  const data = await API.post('AiFormRequest', '/save?key=delete', {
    body: {
      categoryId,
    },
  });
  return data;
};
